import { GridColDef } from '@mui/x-data-grid';
import { TFunction } from 'i18next';
import { UnitsEnum } from '../../../../../services/entities/impl/blfApi/apiConstants';
import {
  GrapeMeasureEnum,
  RanchSummaryTableGrapeRow,
} from '../hooks/useGenerateRanchSummaryTableGrapeRows';
import { GrapeColumnEnum } from '../RanchSummaryTableGrape';
import { getDisplayedGrapeValue } from './getDisplayedGrapeValue';

/**
 * Generates an array of column definitions for exporting grape data in a data grid.
 *
 * @param baseColumn - The base column enum value representing the type of grape data.
 * @param baseTitle - The base title for the column headers.
 * @param units - The units enum value indicating whether to use metric or imperial units.
 * @param t - The translation function for localizing column headers.
 * @returns An array of column definitions for the data grid.
 */
export const generateExportColumnsGrapes = (
  baseColumn: GrapeColumnEnum,
  baseTitle: string,
  units: UnitsEnum,
  t: TFunction<'translation', undefined>
): GridColDef[] => [
  {
    field: `${baseColumn}-${GrapeMeasureEnum.totalCount}`,
    headerName: `${t(baseTitle)} ${t('Total')}`,
    type: 'number',
    valueGetter: (value, row) =>
      getDisplayedGrapeValue(
        row as RanchSummaryTableGrapeRow,
        GrapeMeasureEnum.totalCount,
        baseColumn
      ),
  },
  {
    field: `${baseColumn}-${GrapeMeasureEnum.perMeter}`,
    headerName: `${t(baseTitle)} ${t('per')} ${
      units === UnitsEnum.metric ? 'm' : 'ft'
    }`,
    type: 'number',
    valueGetter: (value, row) =>
      getDisplayedGrapeValue(
        row as RanchSummaryTableGrapeRow,
        GrapeMeasureEnum.perMeter,
        baseColumn
      ),
  },
  {
    field: `${baseColumn}-${GrapeMeasureEnum.perPlant}`,
    headerName: `${t(baseTitle)} ${t('per Plant')}`,
    type: 'number',
    valueGetter: (value, row) =>
      getDisplayedGrapeValue(
        row as RanchSummaryTableGrapeRow,
        GrapeMeasureEnum.perPlant,
        baseColumn
      ),
  },
];
